import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { IntegrityMonitorRulesSmartViewsDataProviderFactory } from '../factory/IntegrityMonitorRulesSmartViewsDataProviderFactory';
import { IntegrityMonitorRulesSmartViewsDataProvider } from '../dataProvider/IntegrityMonitorRulesSmartViewsDataProvider';
import { IntegrityMonitorSmartViewData } from '../types';

export class IntegrityMonitorEventsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: IntegrityMonitorRulesSmartViewsDataProviderFactory;
  public dataProvider: IntegrityMonitorRulesSmartViewsDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new IntegrityMonitorRulesSmartViewsDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<IntegrityMonitorSmartViewData> {
    return this.dataProvider.getDataForView();
  }
}
